var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0C12.415 0 16 3.585 16 8C16 12.415 12.415 16 8 16C3.585 16 0 12.415 0 8C0 3.585 3.585 0 8 0ZM8.999 11C8.999 10.448 8.551 10 7.999 10C7.447 10 6.999 10.448 6.999 11C6.999 11.552 7.447 12 7.999 12C8.551 12 8.999 11.552 8.999 11ZM8.999 5C8.999 4.448 8.551 4 7.999 4C7.447 4 6.999 4.448 6.999 5V8C6.999 8.552 7.447 9 7.999 9C8.551 9 8.999 8.552 8.999 8V5Z",
  fill: "#E04D4D"
})));
export { SvgWarning as ReactComponent };